import React from 'react';
export function CertifiedWireSection() {
  return <div className="text-center space-y-6 max-w-4xl mx-auto" data-id="element-1694">
      <h2 className="text-2xl md:text-3xl font-bold text-navy" data-id="element-1695">
        GF Machining Solutions offers you a wide range of certified EDM wires
        perfectly adapted to your machining requirements.
      </h2>
      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-1696">
        A wire EDM machine has a very wide range of applications and the choice
        of wire is crucial in order to obtain the best productivity and optimum
        results in terms of speed, precision and surface finish. Processes for
        technological development, product accreditation and production control
        in cooperation with strategic partners ensure that with GF Machining
        Solutions certified wire your equipment is operating at peak precision
        and performance. Even if you do not have any GF Machining Solutions
        machines, you can benefit from Operations Support.
      </p>
      <div className="pt-6" data-id="element-1697">
        <a href="https://www.peakedm.com/uploaded/files/2022%20GFMS%20Brochures/Wire%20EDM/Certified%20Wire%20for%20EDM.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-block group" data-id="element-1698">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/2022%20Machine%20Photos/Cerified%20Wires.png800x800.png" alt="Certified Wires" className="block max-w-full h-auto mx-auto mb-4 group-hover:opacity-90 transition-opacity" data-id="element-1699" />
          <span className="text-navy font-bold text-lg underline group-hover:text-orange transition-colors" data-id="element-1700">
            Certified Wire Brochure
          </span>
        </a>
      </div>
    </div>;
}